import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../type';

export const answerSelector = (state: RootState) => state.answer;

export const isAnswerSelector = createSelector(
  answerSelector,
  (state) => state
);
